module.exports = __webpack_public_path__ + "img/subscribe-and-approve-subscriptions.44e585e9.png";